import { isNullOrUndefined } from "common"
import { II18nextTypes } from "common/src/types/i18n";
import { IAddBookingObjType, IBookingType, IEstimateType, ISettingsType, ITripDataType, IUserType } from "common/src/types";


export interface ValidateBookingObjectNewProps {
    isTaximeter: boolean;
    estimate: IEstimateType
    passenger: Partial<IUserType>;
    drivers: IUserType[] | undefined
    tripdata: ITripDataType | undefined
    payment_mode: IBookingType["payment_mode"]
    settings: ISettingsType | undefined | null
}

export const ValidateBookingObjectNew = async ({
    drivers,
    settings,
    tripdata,
    passenger,
    estimate,
    isTaximeter,
    payment_mode,
}: ValidateBookingObjectNewProps): Promise<{ addBookingObj?: IAddBookingObjType; error?: boolean; msg?: keyof II18nextTypes }> => {
    if (isNullOrUndefined(settings) || isNullOrUndefined(tripdata) || isNullOrUndefined(drivers)) {
        return { error: true, msg: 'error' }
    }

    try {

        const addBookingObj: Partial<IAddBookingObjType> = {
            drivers,
            isTaximeter,
            estimate: estimate,
            settings: settings,
            drop: estimate.drop,
            userDetails: passenger,
            pickup: estimate.pickup,
            booking_type_admin: false,
            payment_mode: payment_mode,
            tripdate: new Date().getTime(),
            carDetails: estimate.carDetails,
        };


        if (!isTaximeter && drivers && drivers.length > 0) {
            let requestedDrivers: Record<string, boolean> = {}

            for (let i = 0; i < drivers.length; i++) {
                const driver = drivers[i];
                const driverId = driver.id || driver.uid;

                requestedDrivers[driverId!] = true;
            }

            addBookingObj.requestedDrivers = requestedDrivers;

        }

        return { addBookingObj: addBookingObj as any }
    } catch (error) {
        return { error: true, msg: error as any }
    }
}
